
import { Row, Col } from "react-bootstrap";
import { ComparisonContext } from "../../../../config/context/comparisonContext";
import { useContext } from "react";

const CompareBrake = () => {

    const { compareDetails, setCompareDetails } = useContext(ComparisonContext);

    const carData = compareDetails.first || compareDetails.second || compareDetails.third || compareDetails.fourth
    const brakeSpecList = carData?.specs?.[6] // index 1 have engine specific records
    const firstCarSpecs = compareDetails?.first?.specs?.[6]
    const secondCarSpecs = compareDetails?.second?.specs?.[6]
    const thirdCarSpecs = compareDetails?.third?.specs?.[6]
    const fourthCarSpecs = compareDetails?.fourth?.specs?.[6]

    return (
        <div className="App">
            {brakeSpecList && Object.keys(brakeSpecList).map((spec: any, index: number) => (
                <Row className="border-bottom px-0" key={index}>
                    <Col md={2} className=" comparsion-img-out text-start border-end">
                        <p className="text-start mt-2">{brakeSpecList[spec].name}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{firstCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{secondCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start border-end">
                        <p className="text-start text-dark is-description mt-2">{thirdCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                    <Col md={2} className="comparsion-img-out text-start">
                        <p className="text-start text-dark is-description mt-2">{fourthCarSpecs?.[spec].value || '-'}</p>
                    </Col>
                </Row>
            )) }

        </div >
    );
};

export default CompareBrake;
